// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-F":"F_solar-60w-F__k7enL"};